import controller from '../../../../Scripts/Controller.js';

function MegaMenuController(currentControlElement) {
    let navigation;
    let megamenus;
    let controlElements;
    let currentMegaMenu;
    let isExpanded = false;
    function init() {
        navigation = document.getElementById('Navigation');
        controlElements = document.querySelectorAll('[data-megamenu-controls]');
        megamenus = document.querySelectorAll('[data-megamenu-id]');
        currentMegaMenu = [...megamenus].filter((i) => i.dataset.megamenuId == currentControlElement.dataset.megamenuControls)[0];
        currentControlElement.addEventListener('click', (e) => {
            e.preventDefault();
            isExpanded = currentControlElement.getAttribute('aria-expanded') == 'true';

            megamenus.forEach((megamenu) => {
                megamenu.setAttribute('data-nav-expanded', false);
            });

            controlElements.forEach((controlElement) => {
                controlElement.setAttribute('aria-expanded', false);
            });

            currentControlElement.setAttribute('aria-expanded', !isExpanded);
            navigation.setAttribute('data-nav-expanded', !isExpanded);
            currentMegaMenu.setAttribute('data-nav-expanded', !isExpanded);
        })
    }
    return {
        init: init
    }
}

controller.add('MegaMenuController', MegaMenuController);

export default MegaMenuController;